import { render, staticRenderFns } from "./ViewDay.vue?vue&type=template&id=bb878a70&"
import script from "./ViewDay.vue?vue&type=script&lang=js&"
export * from "./ViewDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports